<template>
  <DeepIcon
    v-if="isDeepAnalyzeNode({ type, name })"
    :height
    name="file-deep-analyze"
    :width
  />
  <DeepNodeIcon
    v-else
    :color="
      type === 'folder' ? getTplColorByName('primary-lighten-1') : undefined
    "
    :height
    :mime-type
    :name
    :type
    :width
  />
</template>

<script setup lang="ts">
import { isDeepAnalyzeNode } from '@/utils/helpers/externals.ts'
import { DeepIcon, DeepNodeIcon, useTplColors } from '@deepcloud/deep-ui-lib'
import type { ExtractProps } from '@deepcloud/deep-ui-utils/vue'

defineProps({
  type: {
    type: String as PropType<ExtractProps<typeof DeepNodeIcon>['type']>,
    default: undefined,
  },
  name: {
    type: String,
    default: undefined,
  },
  mimeType: {
    type: String,
    default: undefined,
  },
  height: {
    type: [String, Number],
    default: undefined,
  },
  width: {
    type: [String, Number],
    default: undefined,
  },
})

const { getTplColorByName } = useTplColors()
</script>
